export default "__VITE_ASSET__0acf3891__"